import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.section `
  color: var(--accountFgColour);
  margin-top: 75px;
  margin-bottom: 15px;
  position: relative;
`;
const Inner = styled.div ``;
const TabList = styled.div `
  display: flex;
  gap: ${fluid(6, 16)};
  align-items: flex-end;
  border-bottom: 2px solid ${brand.white};
`;
const TabItem = styled.div `
  @media ${until(Device.Tablet)} {
    flex: 1 1 15%;
  }
`;
const TabLink = styled.a `
  ${transition('color')};
  ${fonts.apparat.semiBold};

  position: relative;
  font-size: ${fluid(14, 20)};
  line-height: ${fluid(16, 32)};
  margin: 0;
  color: ${brand.white};
  text-decoration: none;
  padding: 7px 20px;
  display: inline-block;
  text-align: center;

  @media ${until(Device.Tablet)} {
    padding: 7px;
    width: 100%;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }

  &.focus-ring {
    text-decoration-color: currentColor;
  }

  span {
    position: relative;
  }

  &::before {
    ${transition('background-color, transform')};

    content: '';
    position: absolute;
    inset: 0;
    height: 100%;
    width: 100%;
    background-color: var(--accountInnerBg);
    transition: width 0.3s;
    border-radius: 10px 10px 0 0;
  }

  &[data-current-tab='true'],
  &:hover {
    color: var(--accountHighlightColourSecondary);

    &::before {
      background-color: var(--accountFormBgColour);
      transform: scaleY(1.15) translateY(-3px);
    }
  }
`;
const ProfileTabsStyles = {
    Container,
    Inner,
    TabItem,
    TabLink,
    TabList,
};
export default ProfileTabsStyles;
